export default __webpack_public_path__ + "static/media/fw-charlotte-er-White Gold.a9d9d506.mp4";